import ImpressionTrackerNew from 'components/impression-tracker/new-impression-tracker';
import { SegmentationIds } from 'constants/segmentation';
import { useReviewsTest } from 'contexts/reviews-test';
import { useSegmentationContext } from 'contexts/segmentation';
import useIsClient from 'hooks/common/use-is-client';
import useModifyJudgeMe from 'hooks/product/judge-me/use-modify-judge-me';
import { StaticPDPProduct } from 'modules/product-details/types';
import style from './judge-me-reviews.module.css';
import useJudgeMeReviewsTracking from './use-judge-me-reviews-tracking';

interface Props {
  product: StaticPDPProduct;
}

/**
 * JudgeMeReviews component.
 * It's rendered in the Product Details page usign the JudgeMe API.
 */
const JudgeMeReviews: React.FC<Props> = ({ product }) => {
  const { isClient } = useIsClient();
  const { segmentation } = useSegmentationContext();

  const { loading5970, loading5971, testData5970, testData5971, variant5971 } =
    useReviewsTest();

  const widgetRef = useModifyJudgeMe({
    product,
    segmentId: segmentation as SegmentationIds,
    loading5971,
    data5971: testData5971,
    variant5971,
    loading5970,
    data5970: testData5970,
  });
  useJudgeMeReviewsTracking(widgetRef);

  if (!isClient) return null;

  return (
    <ImpressionTrackerNew element="PDP Reviews">
      <div
        className={`container ${style['reviews-container']}`}
        data-test="reviews-container"
      >
        <div
          className="jdgm-widget jdgm-review-widget jdgm-outside-widget font-sans text-grey-700"
          data-id={product.id}
          data-product-title={product.title}
          ref={widgetRef}
        />
      </div>
    </ImpressionTrackerNew>
  );
};

export default JudgeMeReviews;
